class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.summaries = this.querySelectorAll('summary');
    this.addEventListeners();
  }

  addEventListeners() {
    this.summaries.forEach((summary) => {
      summary.addEventListener('click', (event) => {
        const details = event.currentTarget.parentNode;
        if (details.hasAttribute('open')) {
          this.closeAll(details);
        }
      });
    });
  }

  closeAll(openDetails) {
    this.querySelectorAll('details[open]').forEach((details) => {
      if (details !== openDetails) {
        details.removeAttribute('open');
      }
    });
  }
}

customElements.define('collapsible-content', CollapsibleContent);
